import React from "react";
import Section, {SectionProps} from "@/Molecules/Section";

export default (
  props: {
  } & SectionProps
) => {

  return <Section
    {...props}
    titleAs={'h1'}
    dark
  />
}
